<template>
    <div class="card card-custom mt-6 mx-5">
        <div class="card-header card-header-tabs-line" style="min-height: 0;">
            <div class="card-toolbar">
                <ul class="nav nav-tabs nav-bold nav-tabs-line">
                    <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                        <a class="nav-link cursor-pointer px-5 py-5"
                           :class="{ 'active': isTabActive(tab) }"
                           @click="changeTab(tab)"
                        >
                        <span class="nav-icon">
                            <i :class="tab.icon"></i>
                        </span>
                            <span class="nav-text">
                            {{ tab.title }}
                        </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="card-body">
            <div v-if="loading" class="text-5xl text-primary">
                <spinner class="text-center pb-6 pt-4" :size="32" line-fg-color="#795BF3"/>
            </div>
            <div class="tab-content">
                <div class="tab-pane fade active show" role="tabpanel">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from 'vue-simple-spinner';

export default {
    components: {
        Spinner,
    },

    props: {
        initFilters: Object,
    },
    data() {
        return {
            loading: false,
            tabs: [
                {
                    id: 'metrics',
                    title: this.__('statistics.link.online_visibility'),
                    icon: 'fas fa-chart-bar',
                    routeName: 'statistics.metrics',
                },
                {
                    id: 'product',
                    title: this.__('statistics.link.articles'),
                    icon: 'fa fa-industry',
                    routeName: 'statistics.products',
                },
                {
                    id: 'brand',
                    title: this.__('statistics.link.brands'),
                    icon: 'fa fa-briefcase',
                    routeName: 'statistics.brands',
                },
                {
                    id: 'categories',
                    title: this.__('statistics.link.categories'),
                    icon: 'fa-solid fa-tags',
                    routeName: 'statistics.categories',
                },
                {
                    id: 'bestSellerProducts',
                    title: this.__('statistics.link.best_seller_products'),
                    icon: 'fas fa-tshirt',
                    routeName: 'statistics.best-seller-products',
                },
                {
                    id: 'bestSellerBrands',
                    title: this.__('statistics.link.best_seller_brands'),
                    icon: 'fas fa-chart-line',
                    routeName: 'statistics.best-seller-brands',
                },
                {
                    id: 'articlesWithPrices',
                    title: this.__('statistics.link.price_comparison'),
                    icon: 'fa fa-balance-scale',
                    routeName: 'statistics.store.articles-with-prices',
                    query: {inventory_status: 'IN_STOCK'},
                },
                {
                    id: 'articlesWithOutOfStockPrices',
                    title: this.__('statistics.link.price_comparison_out_of_stock'),
                    icon: 'fa fa-history',
                    routeName: 'statistics.store.articles-with-prices',
                    query: {inventory_status: 'OUT_OF_STOCK'},
                },
                {
                    id: 'listingRecommendations',
                    title: this.__('statistics.link.listings'),
                    icon: 'fa fa-lightbulb',
                    routeName: 'statistics.listings',
                },
            ],
        };
    },

    methods: {
        changeTab(tab) {
            this.loading = true;
            this.$inertia.visit(this.$route(tab.routeName, {
                storeUuid: this.$page.props.store.id,
                filter: JSON.stringify(this.initFilters),
                ...tab.query,
            }), {
                onFinish: () => {
                    this.loading = false;
                },
            });
        },

        getQueryParams() {
            const params = new URLSearchParams(window.location.search);
            const query = {};
            for (const [key, value] of params.entries()) {
                query[key] = value;
            }
            return query;
        },

        isTabActive(tab) {
            const currentQuery = this.getQueryParams();
            const tabQuery = tab.query || {};
            return (
                tab.routeName === this.$route().current() &&
                Object.keys(tabQuery).every(key => currentQuery[key] === tabQuery[key])
            );
        },
    },
};
</script>
